import { useEffect, useState } from 'react';
import { postFetcher } from '@/api/fetchers';
import type { Filter } from '@/schemas/API/POST/statistics/request';
import { createKey } from '@/api/params';

export interface PagingOptions {
  page: number;
  size: number;
  sort: string[];
}
export const useStatistics = <T>(
  category: string,
  filter: Filter | null,
  paging: PagingOptions
) => {
  const [data, setData] = useState<T>(); 
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false); 

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);  
      setError(null);  
      try {
        const requestBody = filter;  
        const endpoint = `statistics/${category}` + createKey(paging);
        const fetchedData = await postFetcher(endpoint, requestBody);  
        setData(fetchedData);  
      } catch (e) {
        setError('Failed to fetch data'); 
      } finally {
        setIsLoading(false);  
      }
    };

    if (filter) {
      fetchData();  
    }
  }, [category, filter, paging]);  

  return {
    data,
    error,
    isLoading,
  };
};
